import '../../@glimmer/validator/index.js';
import '../../shared-chunks/reference-BNqcwZWH.js';
import '../../shared-chunks/capabilities-DGmQ_mz4.js';
import { setModifierManager as setModifierManager$1 } from '../../@glimmer/manager/index.js';
export { modifierCapabilities as capabilities } from '../../@glimmer/manager/index.js';
export { on } from './on.js';
import '../../shared-chunks/fragment-EpVz5Xuc.js';
import '../../shared-chunks/index-CSVCFS_p.js';
import '../../shared-chunks/index-DZLHQAlb.js';
import '../-internals/container/index.js';
import '../../shared-chunks/super-Cm_a_cLQ.js';
import '../-internals/environment/index.js';
import '../../shared-chunks/on-CrTl7JQU.js';
import '../../shared-chunks/constants-b-2IVErl.js';
import '../runloop/index.js';

// NOTE: this uses assignment to *require* that the `glimmerSetModifierManager`
// is legally assignable to this type, i.e. that variance is properly upheld.
const setModifierManager = setModifierManager$1;

export { setModifierManager };
